import { useLight } from "@Light/services/light";
import { useScaffold } from "@Light/scaffold";
import { useHeaderBackNavigate } from "@Light/components/page/header/context";
import { Query, QueryLoader } from "@Light/components/app/QueryLoader";
import { BillingContent } from "./BillingContent";

export type BillingProps = {
  hideBack?: boolean;
};

export const Billing: React.FC<BillingProps> = ({ hideBack }) => {
  useHeaderBackNavigate(hideBack ? undefined : "/dash/");

  const { useGetBillingInvoicesQuery } = useLight();
  const billingInvoices = useGetBillingInvoicesQuery();

  const scaffold = useScaffold();
  const PageBody = scaffold.page.pageBody;
  return (
    <PageBody>
      <div className="pt-8">
        <QueryLoader
          queries={[billingInvoices as Query]}
          errorMessage="Error loading invoice data. Please try again later."
        >
          <BillingContent billingInvoices={billingInvoices.data?.data ?? []} />
        </QueryLoader>
      </div>
    </PageBody>
  );
};
